import React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import FallbackImage from "@/images/blog/generic-image.png"
import SanityGatsbyImage from "@/components/SanityGatsbyImage"
import { gtmTracking } from "@/utils/gtm-tracking"

const FeaturedBlogPostPreview = ({ post }) => {
  const { t } = useTranslation()

  return (
    <Link
      className="featured-blog-post-preview"
      to={post.frontmatter.slug}
      onClick={() =>
        gtmTracking(
          "Link Click",
          post.frontmatter.title,
          `Primary Featured Blog Post | Category: ${
            post.frontmatter.categories[0].charAt(0).toUpperCase() +
            post.frontmatter.categories[0].slice(1)
          }`,
        )()
      }
    >
      <div className="featured-blog-post-preview__image-container">
        {post.frontmatter.social_image ? (
          post.internal.type === "SanityBlogPost" ? (
            <SanityGatsbyImage
              image={post.frontmatter.social_image}
              maxWidth={620}
              alt={post.frontmatter.title}
              style={{
                width: "100%",
                height: "100%",
              }}
              objectFit="cover"
            />
          ) : (
            <GatsbyImage
              image={
                getImage(post.frontmatter.social_image.src) ?? FallbackImage
              }
              alt={post.frontmatter.title}
              className="featured-blog-post-preview__image"
            />
          )
        ) : (
          <img
            src={FallbackImage}
            alt={post.frontmatter.title}
            className="featured-blog-post-preview__image"
          />
        )}
      </div>

      <div className="featured-blog-post-preview__content">
        <h2 className="featured-blog-post-preview__title mb-6">
          {post.frontmatter.title}
        </h2>

        <p className="p--lg">{post.frontmatter.summary}</p>

        <p className="featured-blog-post-preview__author">
          {post.frontmatter.author}

          {post.internal.type !== "SanityBlogPost" &&
            post.fields.timeToRead &&
            ` · ${t("blog.min-read", { min: post.fields.timeToRead })}`}
        </p>
      </div>
    </Link>
  )
}

export default FeaturedBlogPostPreview
